/*
 * @Description: 
 * @Date: 2025-09-01 10:22:20
 * @LastEditTime: 2026-10-26 11:33:50
 * @FilePath: \hui_ai_ui\src\api\ai\chat.js
 */
// src/api/ai/chat.js

import { dynamicService } from '../index';
import { getApiBaseUrl, isTauri } from '@/config';
import SSEConnection from '@/utils/sse';
// 仅移动端 Tauri 环境使用 plugin-http 的 fetch 绕过 WebView CORS
import { fetch as tauriFetch } from '@tauri-apps/plugin-http';
const isMobileTauri = isTauri && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const safeFetch = isMobileTauri ? tauriFetch : window.fetch.bind(window);

// 获得聊天历史
export function fetchChatHistoryApi(params) {
  const path = `/api/v1/chat/history`;
  return dynamicService.get(path, { params });
}

// 更新聊天历史内容
export function updateChatHistoryApi(params) {
  const path = `/api/v4/chat/history/update_multiple_content`;
  return dynamicService.put(path, params);
}

// 融合聊天历史的多模型对话内容 (流式响应)
export function compositiveChatHistoryApi(chatHistoryId, params) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v4/chat/history/${chatHistoryId}/compositive`;
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(params),
    headers: headers,
  });
}

// 生成和获取会话ID
export function generateChatSessionApi(params) {
  const path = `/api/v1/chat_session/generate_chat_session`;
  return dynamicService.post(path, params);
}

// 提交聊天反馈
export function submitChatFeedback(chatHistoryId, data) {
  const path = `/api/v4/chat/history/${chatHistoryId}/feedback`;
  return dynamicService.put(path, data);
}

// 发送聊天信息 (修正：使用 fetch 并动态获取 URL)
export function sendMessageApi(params) {
  const baseUrl = getApiBaseUrl(); // ◀️ 2. 在调用时动态获取正确的域名
  const url = baseUrl + `/api/v4/chat/send`; // v4 知识库多文件
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}
export function sendbotShare(params) {
  const baseUrl = getApiBaseUrl(); // ◀️ 2. 在调用时动态获取正确的域名
  const url = baseUrl + `/api/v1/bot_chat/send`; // v4 知识库多文件
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}
// 商品导购
export function sendShopping(params) {
  const baseUrl = getApiBaseUrl(); // ◀️ 2. 在调用时动态获取正确的域名
  const url = baseUrl + `/api/v1/shopping_guide/chat`; // v4 知识库多文件
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}

export function sendSkillApi(params) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/tasks/chat`; // v1 技能问答
  const headers = { "Content-Type": "application/json" };
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(params),
    headers: headers,
  });
}


// 添加聊天记录
export function addChatHistoryApi(params) {
  const path = `/api/v1/chat/history`;
  return dynamicService.post(path, params);
}

// 获得建议问题 ai试着问问
export function sugQues(params) {
  const path = `/api/v4/chat/suggested_questions`;
  return dynamicService.post(path, params);
}

// 获得聊天历史详情
export function fetchChatHistoryDetailApi(id) {
  const path = `/api/v1/chat/history/${id}`;
  return dynamicService.get(path);
}

// 清空聊天历史
export function clearChatHistoryApi(params) {
  const path = `/api/v1/chat/clear_history`;
  return dynamicService.delete(path, { params });
}

// 发送语音聊天信息 (修正：使用 fetch 并动态获取 URL)
export function sendVoiceMessageApi(params) {
  const baseUrl = getApiBaseUrl(); // ◀️ 3. 同样在这里动态获取正确的域名
  const url = baseUrl + `/api/v1/chat/send_voice`; // v2/chat/send_voice
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: params,
    headers
  });
}

// 上传图片到OSS
export function uploadChatImageToOSS(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/oss/chat/upload/image`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers
  });
}
// 商品导购
export function uploadShopImageToOSS(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/oss/shopping_guid/upload/image`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers
  });
}

// 上传文档文件到OSS（用于文档解读）
export function uploadChatFileToOSS(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v1/oss/tasks/upload/attachment`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers
  });
}

// 语音转文字
export function speechToTextApi(formData) {
  const baseUrl = getApiBaseUrl();
  const url = baseUrl + `/api/v4/chat/speech_to_text`;
  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return fetch(url, {
    method: "POST",
    body: formData,
    headers: headers,
  });
}

// 建立 SSE 连接，接收实时推送消息
export function createSSEConnection(userId) {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}/api/v1/tasks/sse/${userId}`;

  const headers = {};
  const pctoken = sessionStorage.getItem('pctoken');
  if (pctoken) {
    headers['Authorization'] = `Bearer ${pctoken}`;
    headers['Client-channel'] = isTauri ? 'pc' : 'web';
  }
  return new SSEConnection(url, { headers, fetch: safeFetch });
}